// extracted by mini-css-extract-plugin
export default {"button":"U4UjyH","clickableArea":"NHVyAh","icon":"cXULmD","facebook":"YYvuv0","twitter":"UL7TPh","linked-in":"uuVeWU","linkedIn":"uuVeWU","print":"RdBKHs"};